import { render, staticRenderFns } from "./product-language-select.vue?vue&type=template&id=1f00fd99&scoped=true&"
import script from "./product-language-select.vue?vue&type=script&lang=js&"
export * from "./product-language-select.vue?vue&type=script&lang=js&"
import style0 from "./product-language-select.vue?vue&type=style&index=0&id=1f00fd99&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f00fd99",
  null
  
)

export default component.exports